<template>
    <div class="mobile-flame-wrapper">
      <div v-if="isClient">
        <video
          class="mobile-flame-video"
          preload="auto"
          poster="/images/placeholder_video.webp"
          autoplay
          muted
          loop
          playsinline
          :src="presentation"
        >
          Your browser does not support the video tag.
        </video>
      </div>
      <div v-else class="mobile-flame-skeleton"></div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'MobileFlameDisplay',
    props: {
      presentation: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        isClient: false
      }
    },
    mounted () {
      this.isClient = true
    }
  }
  </script>
  
  <style scoped>
  .mobile-flame-wrapper {
    z-index: 100;
    display: block;
    text-align: center;
    flex-basis: 360px;
    border: 14px solid rgb(206 240 255);
    border-radius: 38px;
    overflow: hidden;

    @media only screen and (max-width: 568px) {
      flex-basis: 100%;
      border: 0;
      border-radius: 0;
    }
  }


  .mobile-flame-video {
    width: 360px;
    height: 640px;
    object-fit: cover;
    display: block;
    margin: 0 auto;
    @media only screen and (max-width: 568px) {
        width: 100%;
        height: 100%;
    }
  }
  
  .mobile-flame-skeleton {
    width: 360px;
    min-height: 640px;
    background-color: #f0f0f0;
    animation: pulse 1.5s infinite ease-in-out;
  }
  
  @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.4; }
    100% { opacity: 1; }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/materials/MobileFlameDisplay.vue